<div class="modal-wrapper">
  <h2 mat-dialog-title>{{ $Locale.get("file-drop/title") }}</h2>
  <mat-dialog-content>
    <p>{{ $Locale.get("file-drop/message") }}</p>
    <p>
      {{ $Locale.get("file-drop/message2") }}
      <br>
      <b>{{ $Locale.get("file-drop/format") }}</b>
    </p>
    <div class="drop-zone-wrapper">
      <div class="drop-zone" (drop)="dropHandler($event)" (dragover)="dragOverHandler($event)">
        <i *ngIf="!fileName">{{ $Locale.get("file-drop/drag") }}</i>
        <i *ngIf="fileName">{{ $Locale.get("file-drop/uploaded") }} <u>{{ fileName }}</u></i>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end"> 
    <button mat-stroked-button (click)="upload()" [disabled]="!data" class="upload-button">{{ $Locale.get("file-drop/upload") }}</button>
    <button mat-stroked-button (click)="close()">{{ $Locale.get("file-drop/close") }}</button>
  </mat-dialog-actions>
</div>